import React from "react";
import axios from "axios";

import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faEraser,
  faClock,
  faPaintBrush,
  faUpload
} from "@fortawesome/fontawesome-free-solid";
import "regenerator-runtime/runtime";

function isCompleted(checklist, name) {
  const step = checklist.find(x => x.name === name);

  if (step) {
    return step.complete;
  }

  return false;
}

function getStepClasses(checklist, stepNum) {
  // warning: this assumes that the steps are done in order,
  // might need to change this up
  // clone and reverse array to find the last completed

  // translate, time, typeste
  const completedStep1 = checklist.every(x => {
    if (["Translated", "Timed", "Typeset"].includes(x.name)) {
      return x.complete;
    }

    return true;
  });

  if (stepNum === 1) {
    if (completedStep1) {
      return "is-completed";
    }

    return "is-active";
  }

  const qcStep = checklist.find(x => x.name === "QC");

  if (stepNum === 2) {
    if (!completedStep1) {
      return "";
    }

    if (qcStep.complete) {
      return "is-completed";
    }

    return "is-active";
  }

  if (stepNum === 3) {
    const encodingStep = checklist.find(x => x.name === "Encoded/Uploaded");

    if (!completedStep1 || !qcStep.complete) {
      return "";
    }

    if (!encodingStep) {
      return "";
    }

    if (encodingStep.complete) {
      return "is-completed";
    }

    return "is-active";
  }

  return "";
}

export default class Progress extends React.Component {
  constructor(props) {
    super(props);
    // set initial state to loading
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    const url = "https://once.zone/.netlify/functions/trello";

    // fetch data
    this.getCards(url);
  }

  async getCards(url) {
    let res;
    try {
      res = await axios.get(url);
    } catch (err) {
      console.error("Failed fetching function data:", err);
      this.setState({success: false});
    }

    // save data to state
    const {success, data, lastUpdate} = res.data;
    this.setState({success, data, lastUpdate, loading: false});
  }

  render() {
    const {loading, success, data, lastUpdate} = this.state;

    if (loading) {
      return (
        <div>
          Loading progress...
        </div>
      );
    }

    if (!success) {
      return (
        <div>
          Something went wrong... :(
        </div>
      );
    }

    const mergedData = data.encoding
      .concat(data.qc)
      .concat(data.inProgress);

    if (mergedData.length) {
      return (
        <div>
          {
            mergedData.map(card => (
              <div className="section" key={card.name}>
                <h4 className="title is-4">
                  {card.name}
                </h4>
                <div className="steps is-medium" key={card.name}>
                  <div className={`step-item ${getStepClasses(card.checklist, 1)}`}>
                    <div className="step-marker">
                      1
                    </div>
                    <div className="step-details">
                      <div>
                        <p className="step-title">
                          Step 1
                        </p>
                        <p>
                          <span
                            className={`icon ${isCompleted(card.checklist, "Translated") ? "has-text-primary" : ""}`}
                            style={{marginRight: "5px"}}
                          >
                            <FontAwesomeIcon icon={faGlobe} />
                          </span>
                          Translation
                        </p>
                        <p>
                          <span
                            className={`icon ${isCompleted(card.checklist, "Timed") ? "has-text-primary" : ""}`}
                            style={{marginRight: "5px"}}
                          >
                            <FontAwesomeIcon icon={faClock} />
                          </span>
                          Timing
                        </p>
                        <p>
                          <span
                            className={`icon ${isCompleted(card.checklist, "Typeset") ? "has-text-primary" : ""}`}
                            style={{marginRight: "5px"}}
                          >
                            <FontAwesomeIcon icon={faPaintBrush} />
                          </span>
                          Typesetting
                        </p>
                      </div>
                      
                    </div>
                  </div>
                  <div className={`step-item ${getStepClasses(card.checklist, 2)}`}>
                    <div className="step-marker">
                      <span className="icon">
                        <FontAwesomeIcon icon={faEraser} />
                      </span>
                    </div>
                    <div className="step-details">
                      <div>
                        <p className="step-title">
                          Step 2
                        </p>
                        <p>
                          QC
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className={`step-item ${getStepClasses(card.checklist, 3)}`}>
                    <div className="step-marker">
                      <span className="icon">
                        <FontAwesomeIcon icon={faUpload} />
                      </span>
                    </div>
                    <div className="step-details">
                      <div>
                        <p className="step-title">
                          Step 3
                        </p>
                        <p>
                          Encoding and Uploading
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }

          <p>
            {`Last update: ${lastUpdate ? lastUpdate.toLocaleString() : "now"}`}
          </p>
        </div>
      );
    }

    return null;
  }
}


// WEBPACK FOOTER //
// ./src/components/Progress/index.jsx